"use client";

import { InputHTMLAttributes } from "react";
import clsx from "clsx";

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  error?: string;
  register?: any;
  endAdornment?: React.ReactNode;
};

export default function FormInput({
  label,
  error,
  register,
  className,
  endAdornment,
  ...props
}: Props) {
  return (
    <div>
      {/* Label */}
      {label && (
        <label className="block text-foreground text-sm mb-1.5">
          {label}
        </label>
      )}

      {/* Input */}
      <div className="relative">
        <input
          {...register}
          {...props}
          className={clsx(
            "bg-input w-full h-11 px-3 text-sm rounded-lg border transition-colors duration-150 focus:outline-none text-foreground placeholder:text-text-muted",
            error
              ? "border-danger bg-danger/5"
              : "border-border",
            "focus:border-primary focus:ring-2 focus:ring-focus-ring/50",
            "disabled:bg-hover disabled:text-text-muted disabled:cursor-not-allowed disabled:border-border-subtle",
            className
          )}
        />
        {endAdornment}
      </div>

      {/* Error */}
      {error && (
        <p className="text-danger text-xs mt-1">
          {error}
        </p>
      )}
    </div>
  );
}